import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, GlobalMessageService, I18nModule, NotAuthGuard, provideDefaultConfig, UrlModule, WindowRef, } from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';
import { LoginFormModule } from '@spartacus/user/account/components';
import { VscaAuthService } from 'src/core/auth/user-auth/facade/vsca-auth.service';
import { VscaLoginFormComponentService } from './vsca-login-form-component.service';
import { VscaLoginFormComponent } from './vsca-login-form.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SanofiJspIncludeMediaDownloadComponent: {
          component: () =>
            import('./vsca-login-form.component').then(
              (m) => m.VscaLoginFormComponent
            ),
        }
      }
    } as CmsConfig)
  ],
  providers: [
    provideDefaultConfig(<CmsConfig> {
      cmsComponents: {
        ReturningCustomerLoginComponent: {
          component: () =>
            import('./vsca-login-form.component').then(
              (m) => m.VscaLoginFormComponent
            ),
          guards: [NotAuthGuard],
          providers: [
            {
              provide: VscaLoginFormComponentService,
              useClass: VscaLoginFormComponentService,
              deps: [VscaAuthService, GlobalMessageService, WindowRef],
            },
          ],
        },
      },
    }),
  ],
  declarations: [VscaLoginFormComponent],
  exports: [VscaLoginFormComponent],
})
export class VscaLoginFormModule extends LoginFormModule {}
